export const defaultShapesValue = () => {
  return {
    num_cols: 0,
    num_rows: 0,
    styles: { width: 500, height: 500, bg_color: "#a8dadc" },
    point_styles: { bg_color: "#302e2e", width: 20 },
    line_styles: { width: 4, border_color: "#606c38" },
    inputs: [],
    angles: [],
    lines: [],
    is_selectable: false,
    margin_percent : 20,
  };
};

export const defaultInputRowValue = () => {
  return {
    text: null,
    x: 0,
    y: 0
  }
}

export const defaultAngleRowValue = () => {
  return {
    dot_row : 0,
    dot_col : 0,
    angle_type : 'A', // Can be A = Acute or O = Obtuse
    arc_width : 30, // default arc width = 30px 
  }
}

export class Dot {
  constructor(x, y, r) {
    this.x = x;
    this.y = y;
    this.r = r;
    this.brightness = 100;
  }
  clicked(px, py) {
    let a = px - this.x;
    let b = py - this.y;
    let d = Math.sqrt(a * a + b * b);

    if (d < this.r) {
      return { x: this.x, y: this.y };
    }
    return null
  }
}
